export const reactSelectDark = {
  control: (base, state) => ({
    ...base,
    // Matches the muted, unmistakably-locked look .ev-form--edit gives every
    // other disabled input in dark mode — react-select draws its own control,
    // so it needs the same treatment spelled out explicitly.
    // The same lifted surface every other field uses in dark — white at 4%,
    // set once in global.scss for real form controls and spelled out here
    // because react-select draws its own control. Translucent on purpose: it
    // sits correctly on a tinted card and on the page alike.
    // Disabled recedes rather than lifts — the same darker fill and fainter
    // edge global.scss gives a disabled input. It used to be a paler blue,
    // which made the controls nobody can touch the loudest on the form.
    backgroundColor: state.isDisabled ? 'rgba(0, 0, 0, 0.28)' : 'rgba(255, 255, 255, 0.04)',
    borderColor: state.isDisabled ? 'rgba(255, 255, 255, 0.07)' : state.isFocused ? '#6ee7b7' : '#3b3b4f',
    opacity: 1,
    // react-select's own base style sets pointerEvents: 'none' on a disabled
    // control — that stops the element from ever being hovered, so the
    // not-allowed cursor below never gets a chance to render. Restoring
    // pointer-events lets the hover (and its cursor) land, while isDisabled
    // still blocks the actual open/select interaction on react-select's side.
    pointerEvents: 'auto',
    // Matches $input-border-radius — react-select draws its own control, so it
    // doesn't inherit the Bootstrap variable.
    borderRadius: 8,
    minHeight: '42px',
    color: '#f1f1f1',
    boxShadow: 'none',
    cursor: state.isDisabled ? 'not-allowed' : 'default',
    '&:hover': {
      borderColor: state.isDisabled ? 'rgba(255, 255, 255, 0.07)' : '#5a5a72'
    }
  }),

  menu: (base) => ({
    ...base,
    backgroundColor: '#282a2c',
    color: '#f1f1f1',
    borderRadius: 6,
    marginTop: 4,
    zIndex: 9999
  }),

  option: (base, { isFocused, isSelected }) => ({
    ...base,
    backgroundColor: isSelected ? 'rgba(110, 231, 183, 0.15)' : isFocused ? 'rgba(110, 231, 183, 0.1)' : '#282a2c',
    color: isSelected ? '#6ee7b7' : '#f1f1f1',
    fontWeight: isSelected ? 600 : 400,
    cursor: 'pointer',
    fontSize: '0.85rem',
    // ...base carries react-select's default ':active' of #B2D4FF, so an option
    // flashed blue while the mouse was held down however the rest was themed.
    ':active': { backgroundColor: 'rgba(110, 231, 183, 0.22)' }
  }),

  singleValue: (base, state) => ({
    ...base,
    color: state.isDisabled ? '#8b96a5' : '#f1f1f1',
    cursor: state.isDisabled ? 'not-allowed' : 'default'
  }),

  multiValue: (base) => ({
    ...base,
    backgroundColor: 'rgba(110, 231, 183, 0.15)',
    borderRadius: 4
  }),

  multiValueLabel: (base) => ({
    ...base,
    color: '#6ee7b7',
    fontWeight: 500,
    fontSize: '0.82rem'
  }),

  multiValueRemove: (base) => ({
    ...base,
    color: '#6ee7b7',
    '&:hover': {
      backgroundColor: 'rgba(110, 231, 183, 0.3)',
      color: '#ffffff'
    }
  }),

  placeholder: (base, state) => ({
    ...base,
    color: '#9ca3af',
    cursor: state.isDisabled ? 'not-allowed' : 'default'
  }),

  valueContainer: (base, state) => ({
    ...base,
    minHeight: '32px',
    padding: '0 6px',
    cursor: state.isDisabled ? 'not-allowed' : 'default'
  }),

  indicatorsContainer: (base, state) => ({
    ...base,
    minHeight: '32px',
    cursor: state.isDisabled ? 'not-allowed' : 'default'
  }),

  dropdownIndicator: (base, state) => ({
    ...base,
    color: state.isDisabled ? '#4b5b70' : base.color,
    cursor: state.isDisabled ? 'not-allowed' : 'pointer'
  }),

  indicatorSeparator: (base, state) => ({
    ...base,
    backgroundColor: state.isDisabled ? 'rgba(255, 255, 255, 0.07)' : base.backgroundColor
  })
};
